import { setViewImage } from "../../../store/Slices/ViewManagerSlice";
import { useAppDispatch } from "../../../utils/hooks";
import { useConversationMedia } from "../../../store/api/useConversationMedia";
import { FaPlay } from "react-icons/fa6";
import TextTranslate from "../../../utils/TextTranslate";
import SearchNotFoundAnimation from "../../../components/SearchNotFoundAnimation";
import {
  getMessagePlayUrl,
  type MediaPlayFields,
} from "../../../utils/mediaPlayUrl";

function mediaPlayUrl(message: MediaPlayFields) {
  if (message.message_type === "video") {
    return getMessagePlayUrl(message);
  }
  return String(message.message_content || "").replace(/\\/g, "/");
}

function openMediaGallery(
  dispatch: ReturnType<typeof useAppDispatch>,
  records: MediaPlayFields[],
  index: number,
) {
  const urls = records
    .map((m) => mediaPlayUrl(m))
    .filter((url): url is string => !!url);
  if (!urls.length) return;
  dispatch(
    setViewImage({
      show_image: true,
      image_src: urls,
      currentIndex: Math.min(Math.max(index, 0), urls.length - 1),
    }),
  );
}

export default function Media() {
  const dispatch = useAppDispatch();
  const { data } = useConversationMedia();
  const records = data?.data?.Records || [];

  if (!records.length) {
    return (
      <div className="grid min-h-[50vh] place-content-center gap-4 text-center">
        <SearchNotFoundAnimation />
        <div className="text-[15px] text-lightText">
          <TextTranslate text="No Media Found!" />
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-3 gap-1 overflow-hidden rounded-2xl bg-primary p-1 shadow-sm ring-1 ring-black/[0.04] dark:ring-white/[0.06]">
      {records.map((message, index) => {
        const isVideo = message.message_type === "video";
        const isGif = message.message_type === "gif";
        const thumb = isVideo
          ? message.message_thumbnail
          : message.message_content;

        return (
          <button
            key={message.message_id}
            type="button"
            onClick={() => openMediaGallery(dispatch, records, index)}
            className="relative aspect-square overflow-hidden rounded-lg bg-black/5"
          >
            <img
              className="h-full w-full object-cover"
              src={thumb}
              alt=""
              loading="lazy"
            />
            {(isVideo || isGif) && (
              <span className="absolute inset-0 grid place-content-center bg-black/20">
                {isVideo ? (
                  <FaPlay className="h-8 w-8 rounded-full bg-black/50 p-2.5 text-white" />
                ) : (
                  <span className="rounded bg-black/50 px-1.5 py-0.5 text-[10px] font-bold uppercase text-white">
                    GIF
                  </span>
                )}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
